import React from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import "./Contact.css";

// Bundle Leaflet's marker assets locally (served same-origin) instead of a
// third-party CDN — removes an external dependency and keeps CSP tight.
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

// Set up custom marker icon for Leaflet
const customIcon = new L.Icon({
  iconUrl: markerIcon,
  iconSize: [30, 45],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowUrl: markerShadow,
  shadowSize: [41, 41],
});

const Contact = () => {
  return (
    <div className="contact-wrapper">
      <div className="contact-container">
        
        <div className="contact-info">
          <h2>Contact Us</h2>
          <p>
            <strong>Phone:</strong> +212 6 66 86 28 63 / +212 6 60 73 85 77 / +212 6 44 17 91 30
          </p>
          <p>
            <strong>Email:</strong> vetedafrica@gmail.com
          </p>
          <p>
            <strong>Address:</strong> Institut Agronomique et Vétérinaire Hassan II, Madinat Al Irfane, BP 6202 Rabat, MOROCCO.
          </p>
        </div>

        <div className="contact-map">
          <MapContainer
            center={[33.981447, -6.864176]}
            zoom={17}
            style={{ height: "100%", width: "100%" }}
          >
            <TileLayer
              url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
              attribution='&copy; <a href="https://www.esri.com/en-us/home">Esri</a>, Maxar, Earthstar Geographics, and the GIS User Community'
            />
            <Marker position={[33.981447, -6.864176]} icon={customIcon}>
              <Popup>Institut Agronomique et Vétérinaire Hassan II</Popup>
            </Marker>
          </MapContainer>
        </div>

      </div>
    </div>
  );
};

export default Contact;